"use client";

import { useRouter } from "next/router";
import { useState } from "react";
import { useSelector } from "react-redux";
import locale from "~/locale";
import { RootState } from "~/redux/store";
import { getCurrentBusiness } from "~/utils";

const sparkles = ["✦", "✧", "⋆", "✦"];

export default function SubscriptionPopCard() {

    const router = useRouter()
    const [hovered, setHovered] = useState(false);

    const language = useSelector((state: RootState) => state.language.language)
    // Assuming locale has a specific type, e.g. LocaleType
    const localeText = (locale[language as keyof typeof locale] || locale.en) as any

    return (
        <div
            className={`
                relative rounded-2xl p-[1.5px] w-70 h-[190px] mb-4 mx-1
                transition-all duration-500
                ${hovered ? "shadow-[0_0_32px_4px_rgba(251,146,60,0.35)]" : "shadow-lg"}
            `}
            style={{

            }}
        >
            {/* Inner card */}
            <div
                className="relative rounded-2xl px-4 py-3 flex flex-col items-center gap-3 overflow-hidden h-[190px]"
                style={{
                    background:
                        "linear-gradient(160deg, #fff7ed 0%, #fffbf5 60%, #fef3c7 100%)",
                }}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
            >
                {/* Decorative background blobs */}
                <div className="absolute -top-6 -right-6 w-24 h-24 rounded-full bg-orange-200 opacity-30 blur-2xl pointer-events-none" />
                <div className="absolute -bottom-6 -left-4 w-20 h-20 rounded-full bg-amber-300 opacity-20 blur-2xl pointer-events-none" />

                {/* Floating sparkles */}
                {sparkles.map((s, i) => (
                    <span
                        key={i}
                        className={`
                            absolute text-amber-400 text-xs font-bold select-none pointer-events-none
                            transition-opacity duration-500
                            ${hovered ? "opacity-100" : "opacity-0"}
                        `}
                        style={{
                            top: `${[10, 14, 68, 72][i]}%`,
                            left: `${[8, 80, 6, 84][i]}%`,
                            animationDelay: `${i * 150}ms`,
                            fontSize: `${[10, 8, 9, 11][i]}px`,
                        }}
                    >
                        {s}
                    </span>
                ))}

                {/* Icon badge */}
                <div
                    className={`
                        relative z-10 w-11 h-11 rounded-2xl flex items-center justify-center
                        transition-transform duration-300
                        ${hovered ? "scale-110 rotate-3" : "scale-100"}
                    `}
                    style={{
                        background: "linear-gradient(135deg, #f97316, #fbbf24)",
                        boxShadow: "0 6px 20px rgba(249,115,22,0.4)",
                    }}
                >
                    {/* Crown SVG */}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-7 h-7 text-white drop-shadow"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                    >
                        <path d="M2 18l2-9 4 4 4-8 4 8 4-4 2 9H2z" />
                        <circle cx="2" cy="9" r="1.5" />
                        <circle cx="12" cy="1" r="1.5" />
                        <circle cx="22" cy="9" r="1.5" />
                    </svg>
                    {/* Shine dot */}
                    <span className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-white opacity-70 blur-[1px]" />
                </div>

                {/* Text */}
                <div className="text-center z-10">
                    {/* <p
                        className="text-[11px] font-semibold tracking-[0.18em] uppercase text-orange-400 mb-0.5"
                    >
                        Unlock Power
                    </p> */}
                    <h3
                        className="text-lg font-black text-gray-800 leading-tight"
                    >
                        <span>{localeText?.SubscriptionLocale2?.GoPro}</span>
                    </h3>
                    <p
                        className="text-xs text-gray-500 mt-1 leading-snug max-w-[180px] mx-auto"
                    >
                        <span>{localeText?.SubscriptionLocale2?.Makesmarterdecisionsbackedbyrealbusinessdata}</span>
                    </p>
                </div>

                {/* Stars */}
                {/* <div className="flex items-center gap-1 z-10">
                    {[...Array(5)].map((_, i) => (
                        <svg
                            key={i}
                            xmlns="http://www.w3.org/2000/svg"
                            className={`w-4 h-4 transition-transform duration-200 ${hovered ? "scale-110" : "scale-100"}`}
                            style={{
                                fill: i < 4 ? "#f97316" : "url(#half)",
                                transitionDelay: `${i * 40}ms`,
                            }}
                            viewBox="0 0 24 24"
                        >
                            <defs>
                                <linearGradient id="half">
                                    <stop offset="50%" stopColor="#f97316" />
                                    <stop offset="50%" stopColor="#e5e7eb" />
                                </linearGradient>
                            </defs>
                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 21 12 17.77 5.82 21 7 14.14l-5-4.87 6.91-1.01L12 2z" />
                        </svg>
                    ))}
                    <span
                        className="text-xs text-gray-400 ml-1"
                    >
                        4.9
                    </span>
                </div> */}

                {/* CTA Button */}
                <button
                    className={`
                        relative z-10 w-full py-2 rounded-xl text-white text-sm font-bold tracking-wide
                        transition-all duration-300 overflow-hidden
                        ${hovered ? "scale-[1.03]" : "scale-100"}
                    `}
                    onClick={() => {
                        router.push(`/subscription${getCurrentBusiness() ? `?businessId=${getCurrentBusiness()}` : ''}`)
                    }}
                    style={{
                        background: hovered
                            ? "linear-gradient(135deg, #ea580c, #f97316, #fbbf24)"
                            : "linear-gradient(135deg, #f97316, #fbbf24)",
                        boxShadow: hovered
                            ? "0 8px 24px rgba(249,115,22,0.55)"
                            : "0 4px 12px rgba(249,115,22,0.3)",
                    }}
                >
                    <span className="relative z-10 flex items-center justify-center gap-2 text-[13px]">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-4 h-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2.5}
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M13 10V3L4 14h7v7l9-11h-7z"
                            />
                        </svg>
                        {localeText?.SubscriptionLocale2?.ExploreProPlans && <span>{localeText?.SubscriptionLocale2?.ExploreProPlans}</span>}
                    </span>
                    {/* Shimmer */}
                    <span
                        className={`
                            absolute inset-0 bg-white/10
                            transition-opacity duration-500
                            ${hovered ? "opacity-100 animate-shimmer" : "opacity-0"}
                        `}
                        style={{
                            background:
                                "linear-gradient(120deg, transparent 30%, rgba(255,255,255,0.18) 50%, transparent 70%)",
                            backgroundSize: "200% 100%",
                            animation: hovered ? "shimmer 1.2s infinite" : "none",
                        }}
                    />
                </button>
            </div>

            {/* Shimmer keyframes */}
            <style>{`
                @keyframes shimmer {
                0%   { background-position: -200% 0; }
                100% { background-position: 200% 0; }
                }
                `}
            </style>
        </div>
    );
}